import { Injectable } from '@angular/core';
import { LoginModalComponent } from 'src/app/common/login-modal/login-modal.component';

@Injectable({
  providedIn: 'root'
})
export class LoginModalService {
  component!: LoginModalComponent;
  constructor() {
  }
  bindComponent(component: LoginModalComponent){
    this.component = component;
  }
  getInstance(){
    return this.component;
  }
}
